Vendd.Scripts.load(function () {

	/**
	 * NumberFormatter class
	 * 
	 * Instances of this class may be used to convert numerical literals to native js 
	 * values and vice versa.
	 * 
	 * The formatter is implicitly configured via the LhApp.context.Currency.* properties,
	 * that specify the preferred number of decimal digits, the decimal separator, as well 
	 * as the symbol and position of the effective currency (if applicable).
	 * 
	 * 
	 * Example:
	 * 
	 * // LhApp.Context.Currency.Symbol = 'EUR';
	 * // LhApp.Context.Currency.DecimalSeparator = ',';
	 * // LhApp.Context.Currency.NumberOfDigits = true;
	 * 
	 * var price = PriceFormatter.parsePrice('1000,45 EUR'); // price = 1000.45
	 * var priceLiteral = PriceFormater.formatPrice(45.5); // priceLiteral = '45,50 EUR'
	 * 
	 */

	window.NumberFormatter = new NumberFormatter();

	function NumberFormatter() {
		var self = this;

		var currencySymbol = LhApp.Context.Currency.Symbol || '';
		var currencyFirst = LhApp.Context.Currency.SymbolShownFirst || false;
		var currencyVisible = LhApp.Context.Currency.DoShowSymbol || false;
		var decimalSeparator = LhApp.Context.Currency.DecimalSeparator || '.';
		var decimalDigits = LhApp.Context.Currency.NumberOfDigits || 0;
		var pricePrefix = currencyVisible && currencyFirst ? currencySymbol + ' ' : '';
		var priceSuffix = currencyVisible && !currencyFirst ? ' ' + currencySymbol : '';

		// Public methods

		//------------------------------------------------------------------------------
		this.parse = function (numberLiteral) {
            if (typeof numberLiteral == 'undefined') {
                return undefined;
            }

            if (typeof numberLiteral !== 'string') {
                numberLiteral = numberLiteral.toString();
            }
			
			if (numberLiteral.trim().length === 0) {
				return undefined;
			}

			numberLiteral = numberLiteral.replace(decimalSeparator, '.').trim();
			var number = parseFloat(numberLiteral);

			if (isNaN(number)) {
				return undefined;
			}

			return number;
		};

		//------------------------------------------------------------------------------
		this.parsePrice = function (priceLiteral) {
			if (typeof priceLiteral !== 'string') {
				return undefined;
			}
			if (priceLiteral.trim().length === 0) {
				return undefined;
			}

			priceLiteral = priceLiteral.replace(currencySymbol, '').trim();
			priceLiteral = priceLiteral.replace(decimalSeparator, '.').trim();
			var number = parseFloat(priceLiteral);

			if (isNaN(number)) {
				return undefined;
			}

			return number;
		};

		//------------------------------------------------------------------------------
		this.formatPrice = function (number) {
			if (number === undefined) {
				return '';
			}
			if (isNaN(number)) {
				return '';
			}

			var numberLiteral = self.format(number);

			return pricePrefix + numberLiteral + priceSuffix;
		};

		//------------------------------------------------------------------------------
		this.format = function (number) {
			if (number === undefined) {
				return '';
			}
			if (isNaN(number)) {
				return '';
			}

			var numberLiteral;

			if (0 < decimalDigits) {
				numberLiteral = parseFloat(number).toFixed(decimalDigits);
				numberLiteral = numberLiteral.replace('.', decimalSeparator);
			} else {
				numberLiteral = '' + parseInt(number);
			}

			return numberLiteral;
		};

		//------------------------------------------------------------------------------
		this.formatInt = function (number) {
			if (number === undefined) {
				return '';
			}
			if (isNaN(number)) {
				return '';
			}

			var numberLiteral = '' + parseInt(number);

			return numberLiteral;
		};

		return self;
	};
});
